<app-side-menu>
  <div class="b2b-contracts-vehicle-view-container">
    <app-loading [show]="isLoading" message="Carregando veículo..."></app-loading>

    <div *ngIf="!isLoading && vehicle" class="view-content">
      <div class="header">
        <div class="title-section">
          <button type="button" class="btn-back" (click)="navigateBack()" title="Voltar à tabela de veículos">
            <i class="fas fa-arrow-left"></i>
          </button>
          <div class="title-info">
            <h1>
              <i class="fas fa-motorcycle me-2"></i>
              Veículo {{ vehicle.plate }}
            </h1>
            <p *ngIf="contractNumber">
              Pedido {{ itemNumber }} · Contrato: {{ contractNumber }} — {{ contractName }}
            </p>
          </div>
        </div>
        <div class="action-buttons">
          <button type="button" class="btn btn-primary" (click)="navigateToPedido()">
            <i class="fas fa-list me-2"></i>
            Ir para o pedido
          </button>
          <button type="button" class="btn btn-secondary" (click)="navigateBack()">
            <i class="fas fa-arrow-left me-2"></i>
            Voltar
          </button>
        </div>
      </div>

      <div class="card mb-4">
        <div class="card-header text-white">
          <h3>
            <i class="fas fa-link me-2"></i>
            Pedido relacionado
          </h3>
        </div>
        <div class="card-body">
          <div class="row g-3">
            <div class="col-md-6">
              <label class="form-label">Número do pedido</label>
              <p class="form-control-plaintext">{{ itemNumber || '—' }}</p>
            </div>
            <div class="col-md-6">
              <label class="form-label">Contrato</label>
              <p class="form-control-plaintext">{{ contractNumber || '—' }} — {{ contractName }}</p>
            </div>
          </div>
        </div>
      </div>

      <div class="card mb-4">
        <div class="card-header text-white">
          <h3>
            <i class="fas fa-motorcycle me-2"></i>
            Veículo
          </h3>
        </div>
        <div class="card-body">
          <div class="row g-3">
            <div class="col-md-4">
              <label class="form-label">Placa</label>
              <p class="form-control-plaintext">{{ vehicle.plate }}</p>
            </div>
            <div class="col-md-4">
              <label class="form-label">Marca</label>
              <p class="form-control-plaintext">{{ vehicle.brand }}</p>
            </div>
            <div class="col-md-4">
              <label class="form-label">Modelo</label>
              <p class="form-control-plaintext">{{ vehicle.model }}</p>
            </div>
            <div class="col-md-4">
              <label class="form-label">Ano</label>
              <p class="form-control-plaintext">{{ vehicle.year }}</p>
            </div>
            <div class="col-md-4">
              <label class="form-label">Cor</label>
              <p class="form-control-plaintext">{{ vehicle.color }}</p>
            </div>
            <div class="col-md-4">
              <label class="form-label">KM atual</label>
              <p class="form-control-plaintext">{{ formatKm(vehicle.currentKm) }}</p>
            </div>
            <div class="col-md-6">
              <label class="form-label">RENAVAM</label>
              <p class="form-control-plaintext">{{ vehicle.renavam }}</p>
            </div>
            <div class="col-md-6">
              <label class="form-label">Chassi</label>
              <p class="form-control-plaintext font-monospace small">{{ vehicle.chassis }}</p>
            </div>
            <div class="col-md-4">
              <label class="form-label">Status operacional</label>
              <p class="form-control-plaintext">{{ vehicle.operationalStatus || '—' }}</p>
            </div>
            <div class="col-md-4">
              <label class="form-label">Tipo de rastreador</label>
              <p class="form-control-plaintext">{{ vehicle.trackerType || 'Não informado' }}</p>
            </div>
            <div class="col-md-4">
              <label class="form-label">ID do rastreador</label>
              <p class="form-control-plaintext">{{ vehicle.trackerId || 'Não informado' }}</p>
            </div>
            <div class="col-md-4">
              <label class="form-label">Baú</label>
              <p class="form-control-plaintext">{{ vehicle.hasBox ? 'Sim' : 'Não' }}</p>
            </div>
            <div class="col-md-4">
              <label class="form-label">Suporte de celular</label>
              <p class="form-control-plaintext">{{ vehicle.hasPhoneSupport ? 'Sim' : 'Não' }}</p>
            </div>
            <div class="col-md-4">
              <label class="form-label">Condutor atual</label>
              <p class="form-control-plaintext">{{ vehicle.driverDisplay }}</p>
            </div>
            <div class="col-12" *ngIf="vehicle.inspectionNotes">
              <label class="form-label">Observações de vistoria</label>
              <p class="form-control-plaintext">{{ vehicle.inspectionNotes }}</p>
            </div>
          </div>
        </div>
      </div>

      <div class="card mb-4">
        <div class="card-header text-white">
          <h3>
            <i class="fas fa-paperclip me-2"></i>
            Documentos do veículo
          </h3>
        </div>
        <div class="card-body">
          <div *ngIf="isLoadingAttachments" class="text-muted small mb-2">
            <i class="fas fa-spinner fa-spin me-1"></i> Carregando documentos...
          </div>

          <div *ngIf="!isLoadingAttachments && attachments.length > 0" class="attachments-list">
            <div *ngFor="let att of attachments" class="attachment-item">
              <div class="attachment-info">
                <i class="fas fa-file attachment-icon"></i>
                <div class="attachment-details">
                  <h6>{{ displayAttachmentName(att) }}</h6>
                  <small *ngIf="attachmentSubtitle(att) as sub" class="d-block text-muted">{{ sub }}</small>
                  <small class="text-muted">{{ formatAttachmentSize(att.fileSize) }}</small>
                </div>
              </div>
              <button
                type="button"
                class="btn btn-sm btn-outline-primary"
                title="Baixar"
                (click)="downloadAttachment(att)">
                <i class="fas fa-download"></i>
              </button>
            </div>
          </div>

          <p class="text-muted small mb-0" *ngIf="!isLoadingAttachments && attachments.length === 0">
            Nenhum documento anexado a este veículo na frota.
          </p>
        </div>
      </div>

      <div class="card mb-4">
        <div class="card-header text-white">
          <h3>
            <i class="fas fa-history me-2"></i>
            Histórico de condutores
          </h3>
        </div>
        <div class="card-body">
          <div *ngIf="isLoadingDriverHistory" class="text-muted small mb-2">
            <i class="fas fa-spinner fa-spin me-1"></i> Carregando histórico...
          </div>

          <div class="table-responsive" *ngIf="!isLoadingDriverHistory && driverHistory.length > 0">
            <table class="table table-sm table-striped align-middle mb-0">
              <thead>
                <tr>
                  <th>Condutor</th>
                  <th>CPF</th>
                  <th>Início</th>
                  <th>Fim</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let h of driverHistory">
                  <td>{{ h.driverName }}</td>
                  <td>{{ formatCpf(h.driverCpf) }}</td>
                  <td>{{ formatDate(h.startDate) }}</td>
                  <td>{{ h.endDate ? formatDate(h.endDate) : '—' }}</td>
                  <td>
                    <span [class]="formatDriverHistoryStatusClass(h.status)">
                      {{ formatDriverHistoryStatus(h.status) }}
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <p class="text-muted small mb-0" *ngIf="!isLoadingDriverHistory && driverHistory.length === 0">
            Nenhum vínculo de condutor registrado para este veículo.
          </p>
        </div>
      </div>
    </div>
  </div>
</app-side-menu>
